import 'react-loading-skeleton/dist/skeleton.css';
import "./assets/scss/app.scss";
import Routing from "./routing/Routing";
function App() {
  return <Routing />;
}

export default App;
